import React from 'react';

import {
  GithubOutlined,
  TwitterOutlined,
  LinkedinOutlined,
} from '@ant-design/icons';

import { motion } from 'framer-motion';
import uroTheme from '../../../../utils/theme/themeConfig';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <motion.footer
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.8, type: 'spring', bounce: 0.14 }}
      className='w-full border-t border-white/10'
      style={{
        backgroundColor: uroTheme.colors.navigation.background,
      }}
    >
      <div className='footer-inner container mx-auto px-4 py-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8'>
        <div className='footer-col flex flex-col gap-4'>
          <div className='footer-title text-xl font-extrabold text-white mb-1'>
            Uro
          </div>
          <div className='text-gray-300 mb-2 text-sm md:text-base'>
            AI-powered image generation for everyone.
            <br />
            Instantly generate, upscale, and enhance images via API.
          </div>
          <div className='footer-social flex flex-row gap-4 mt-2'>
            <a
              href='https://github.com'
              target='_blank'
              rel='noopener noreferrer'
              className='text-gray-400 hover:text-white focus:text-white text-2xl transition-colors duration-150'
            >
              <GithubOutlined />
            </a>
            <a
              href='https://twitter.com'
              target='_blank'
              rel='noopener noreferrer'
              className='text-gray-400 hover:text-white focus:text-white text-2xl transition-colors duration-150'
            >
              <TwitterOutlined />
            </a>
            <a
              href='https://linkedin.com'
              target='_blank'
              rel='noopener noreferrer'
              className='text-gray-400 hover:text-white focus:text-white text-2xl transition-colors duration-150'
            >
              <LinkedinOutlined />
            </a>
          </div>
        </div>
        <div className='footer-col'>
          <div className='footer-title text-base font-bold text-white mb-2'>
            Product
          </div>
          <ul className='flex flex-col gap-2'>
            <li>
              <a
                href='/features'
                className='text-gray-400 hover:text-white focus:text-white transition-colors duration-150'
              >
                Features
              </a>
            </li>
            <li>
              <a
                href='/pricing'
                className='text-gray-400 hover:text-white focus:text-white transition-colors duration-150'
              >
                Pricing
              </a>
            </li>
            <li>
              <a
                href='/docs'
                className='text-gray-400 hover:text-white focus:text-white transition-colors duration-150'
              >
                SDK
              </a>
            </li>
          </ul>
        </div>
        <div className='footer-col'>
          <div className='footer-title text-base font-bold text-white mb-2'>
            Company
          </div>
          <ul className='flex flex-col gap-2'>
            <li>
              <a
                href='/about'
                className='text-gray-400 hover:text-white focus:text-white transition-colors duration-150'
              >
                About
              </a>
            </li>
            <li>
              <a
                href='/contact'
                className='text-gray-400 hover:text-white focus:text-white transition-colors duration-150'
              >
                Contact
              </a>
            </li>
            <li>
              <a
                href='/careers'
                className='text-gray-400 hover:text-white focus:text-white transition-colors duration-150'
              >
                Careers
              </a>
            </li>
            <li>
              <a
                href='/blog'
                className='text-gray-400 hover:text-white focus:text-white transition-colors duration-150'
              >
                Blog
              </a>
            </li>
          </ul>
        </div>
        <div className='footer-col'>
          <div className='footer-title text-base font-bold text-white mb-2'>
            Support / Legal
          </div>
          <ul className='flex flex-col gap-2'>
            <li>
              <a
                href='/contact'
                className='text-gray-400 hover:text-white focus:text-white transition-colors duration-150'
              >
                Help Center
              </a>
            </li>
            <li>
              <a
                href='/privacy'
                className='text-gray-400 hover:text-white focus:text-white transition-colors duration-150'
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href='/terms'
                className='text-gray-400 hover:text-white focus:text-white transition-colors duration-150'
              >
                Terms & Policies
              </a>
            </li>
            <li>
              <span className='text-gray-400 select-text'>support@fluxuro.ai</span>
            </li>
            <li>
              <span className='text-gray-500 text-xs'>Shams Business Center, Sharjah Media City FreeZone, Sharjah, UAE</span>
            </li>
          </ul>
        </div>
      </div>
      <div className='footer-bottom container mx-auto px-4 py-4 text-center text-xs text-gray-400 border-t border-white/10'>
        {' '}
        {year} Uro. All rights reserved.
      </div>
    </motion.footer>
  );
};

export default Footer;
